// extracted by mini-css-extract-plugin
export default {"pageSizer":"styles_pageSizer__ghKVV","pageSizerFull":"styles_pageSizerFull__PBKMZ"};